import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const DockerIcon = forwardRef<SVGSVGElement, IconProps>(function DockerIcon(
  { color = '', height = 18, width = 18, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        d="M10.1984 7.22051H12.0651H10.1984ZM7.97622 7.22051H9.84288H7.97622ZM5.79844 7.22051H7.6651H5.79844ZM3.62066 7.22051H5.44288H3.62066ZM1.39844 7.22051H3.2651H1.39844ZM3.62066 5.16592H5.44288H3.62066ZM5.79844 5.16592H7.6651H5.79844ZM7.97622 5.16592H9.84288H7.97622ZM7.97622 3.11133H9.84288H7.97622Z"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.84288 3.95647H7.97622V2.26758H9.84288V3.95647ZM5.44288 6.01106H3.62066V4.32217H5.44288V6.01106ZM7.6651 6.01106H5.79844V4.32217H7.6651V6.01106ZM9.84288 6.01106H7.97622V4.32217H9.84288V6.01106ZM3.2651 8.06565H1.39844V6.37676H3.2651V8.06565ZM5.44288 8.06565H3.62066V6.37676H5.44288V8.06565ZM7.6651 8.06565H5.79844V6.37676H7.6651V8.06565ZM9.84288 8.06565H7.97622V6.37676H9.84288V8.06565ZM12.0651 8.06565H10.1984V6.37676H12.0651V8.06565Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M18.0209 7.31153C18.0209 7.31153 17.2209 6.55223 15.5765 6.82022C15.3987 5.52493 14.0209 4.76562 14.0209 4.76562C14.0209 4.76562 12.7321 6.3289 13.6654 8.07084C13.3987 8.20483 12.9543 8.38349 12.2876 8.38349H0.0653881C-0.156834 9.23213 -0.156834 14.8599 5.9765 14.8599C10.3765 14.8599 13.6654 12.8053 15.2209 9.05347C17.5321 9.23213 18.0209 7.31153 18.0209 7.31153Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
